import { useEffect, useState } from 'react'
import { useLocalForageKey } from '../../../../utils/local-storage/useLocalForageKey.hooks'

export const useStoreSessionToken = (token: string | undefined) => {
  const [tokenStored, setTokenStored] = useState<boolean>(false)

  const { data: existingSession, setData: storeSessionData } = useLocalForageKey<{
    token?: string
    hasRefreshToken?: boolean
  }>('session')

  useEffect(() => {
    async function saveSessionData() {
      if (token) {
        // Merge with existing session to preserve hasRefreshToken flag
        await storeSessionData({
          ...existingSession,
          token,
        })

        setTokenStored(true)
      }
    }

    saveSessionData()
  }, [token, existingSession, storeSessionData])

  return {
    completed: tokenStored,
  }
}
